import { Component, OnDestroy, OnInit,  ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import {DemoService} from './../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Router} from '@angular/router';
import { MysqlService } from './../../services/mysql.service';

import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable} from 'rxjs';



import { FileUploaderService } from './../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import {SubjectServiceComponent} from './../../admin/jobs/subjects/subject-service/subject-service.component';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { GlobalFunctionsService } from './../../services/global-functions.service';

@Component({
  selector: 'app-agent-job-subject',
  templateUrl: './agent-job-subject.component.html',
  styleUrls: ['./agent-job-subject.component.css']
})
export class AgentJobSubjectComponent implements OnInit {

  subjects: any;
  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  subject_notes: any;
  subject_id: number;
  job_status_run: any;
  subject_progress: any;
  job_types: any;
  job_type: any;
  job_type_location: any;
  job_type_court: any;
  job_type_document: any;
  job_type_affidavit: any;
  job_id: any;
  file_number: any;
  subject_service: any;
  subject_services: any;

  bsModalRef: BsModalRef;
  loadComponent: boolean;
  initialPage: any;
  @ViewChild('grid')
  public grid: GridComponent;
  subject_number: any;
  allAgents: any;
  assignedAgentsList: any;
  agent_associated: number;
  sessionUsername: any;
  all_router_details: string;
  current_subject_status: any;
  subject_contact_numbers: any;
  subject_contact_emails: any;
  modalRef: BsModalRef;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient: HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     
    ) {





      this.nav = document.querySelector('nav.navbar');
   

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
      }

  ngOnInit() {
    // Need to do an agent blocker check
    // if current session level = 5 is an agent.
    // if job status pending closed daft
    // if agent not exists in assinged agent array.
        // Block agents from being able to submit or edit anytypes of subect details... focus on attendances and notes.
        if (this.gfunc.sessionUserLevel == 5){
          this.getSubjectAgentBrandsAssigned(this.subject_id);
          }

    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();
    this.getSubjectServiceAll(this.subject_id); // serives list new
    this.getSubjectContactEmails(this.subject_id)
    this.getSubjectContactNumbers(this.subject_id)


  }


ngOnDestroy(){
 // this.subjects.unsubscribe();

}


// no longer being used as would not pass the variables to the ts file.
openModalWithComponent() {
  /* this is how we open a Modal Component from another component */
  console.log('open model');

  const initialState = {
    subject_id: this.subject_id,
    passed_job_id: 'A Fat Cat',
    title: 'Modal Window Title'
  };
  this.bsModalRef = this.modalService.show(SubjectServiceComponent, {initialState});
 this.bsModalRef.content.passed_job_id = 'Close';
  this.bsModalRef.content.job_id = this.job_id;
  this.bsModalRef.content.subject_id = this.subject_id;
};



loadMyChildComponent() {
  this.loadComponent = true;
}

closeMyChildComponent() {
  this.loadComponent = false;
}




  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subjects = data;
        const res = data[0];
        this.getSubjectNotes(res.subject_id);
        // load subject history
        this.getSubjectProgress(res.job_id, res.file_number);

this.current_subject_status = res.job_status;

// get job type in relation to subject
this.getJobType(res.job_type_id);
this.getJobTypeLocation(res.job_type_location_id);
this.getJobTypeCourt(res.job_type_court_id);
this.getJobTypeDocument(res.job_type_document_type_id);
this.getJobTypeAffidavit(res.job_type_affidavit_type_id);

this.job_id = res.job_id;
this.file_number = res.file_number;
this.subject_number = res.subject_number;
// this.getSubjectNotesProgressionTable(res.job_id, res.file_number );


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  // update was here for onit but moved for onchange
  updateJobSubject(model) {

    // first make a copy of subject and place in to subject_history table. // done on insert in PHP

model.updated_by = this.sessionUserId;
    this._demoService.updateJobSubject(model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Subject Updated');
       this.getJobSubject(model.subject_id);
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false);
      this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']);
                 return true;
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error saving Job!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')


  );
  }


  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      data => { this.subject_notes = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }



    private getJobStatusNames() {
      this._demoService.getJobStatusNames()
        .subscribe(
          res => this.job_status_run = res,
          err => console.error(err.status)
        );
    }



// this reports as failes but actually works.

    newSubjectReference(model){
      this._demoService.newSubjectReference(model).subscribe(
        data => { // this.new_subject_data = data; // this is the retuned json upon creation.
        this.toastr.success('New Subject Reference Data Entered');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

         // Setup annd the Currents before we redirec the page
         // Needs to be a Function to update the ObserveOnOperator.
         // this.newCTrace_id(this.latest_trace_id);
         // or this.cdata.changeCTrace_id("999");

       // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

        this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

           return true;


        },
        error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
       //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
       // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
       this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
       this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

         // console.log(error(error));
         //return console.log(error);
        }
    );


    };


    subjectView2(subject_id) {

      this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']));

    // works but does not refresh the page only if set up as a listner.
    // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
   }

   subjectView2Client(subject_id) {

    // :: OLD WAY
    // this.router.navigateByUrl('client/jobs', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/client/jobs/subject/' + subject_id + '']));

    // :: New Way
    this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/client/jobs/subject/' + subject_id + ''])
    );

  // works but does not refresh the page only if set up as a listner.
  // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
 }

   jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  jobViewClient(job_id) {
    this.router.navigate(['/client/jobs/view-job/' + job_id + '']);
  }

  subjectCommunication(subject_id) {
    this.router.navigate(['/admin/jobs/subject/communication/' + subject_id + '']);
  }

  subjectDocuments(subject_id) {
    this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
  }




   getSubjectProgress(job_id, file_number){
    this._demoService.getSubjectProgress(job_id, file_number).subscribe(
      data => { this.subject_progress = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }


// get job type details.
getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => {
      this.job_type = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeLocation(job_type_location_id) {
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
     data => { this.job_type_location = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeCourt(job_type_court_id) {
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
     data => { this.job_type_court = data;
     // let res = data[0];
     // this.model.job_type_id = res.job_type_id;
     // this.getJobTypeLocations(res.job_type_id);


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypeDocument(job_type_document_type_id) {
  this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
     data => { this.job_type_document = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypeAffidavit(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
     data => { this.job_type_affidavit = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





 getSubjectNotesProgressionTable(job_id, file_number, model) {
  this._demoService.getSubjectNotesProgressionTable(job_id, file_number, model).subscribe(
    data => { this.subject_notes = data;
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  ); }








  getSubjectServiceAll(subject_id) {
    this._demoService.getSubjectServiceAll(subject_id).subscribe(
      data => { this.subject_service = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      let res = data[0];

      /*
       this.getServiceMethod(res.subject_service_method_id);
       this.getSubjectRelationship(res.fellow_occupants_relationship);
       this.getExactServiceMethod(res.exact_service_method);
       this.getSubjectServiceOutcome(res.subject_service_outcome_id);
       this.getBrandById(res.who_service); // get agent/brand that served
        this.getSubjectLocationStatus(res.subject_location_status_id);
        this.getSubjectLocationStatusFound(res.subject_location_status_found_id);
       */
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }



    getSubjectServices(subject_id) {
      this._demoService.getSubjectServices(subject_id).subscribe(
        data => { this.subject_services = data;
         // console.log("Done loadng USER");
         // console.log(this.users);
         let res = data[0];

         // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
         // this.getUsersById(res.who_attended);
        },
        error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
        }
      ); }



      deleteSubjectService(subject_service_id) {
        if (confirm('Are you sure you want to delete this Service Information? ')) {
          this._demoService.deleteSubjectService(subject_service_id).subscribe(
             data => {
              this.getSubjectServices(this.subject_id);
               return true;
             },
             error => {
               console.error('Error deleting Attendence!');
              return console.log(error);
             }
          );
      }
      }


      refreshGrid(){ // refresh the databutton
        // this.getFiles();
        // this.getJobFilesGrid(this.model);

       // this.getSubjectNotes(this.subject_id)
         this.grid.refresh();
       };
       



       
// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  console.log('Running Subject Agent Access Checker!!! 101');
    this.allAgents = [];
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
       data => { 
         this.assignedAgentsList = data;
        //  let res = data[0];
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           this.agent_associated = 0;
  
           let array = [];
           let ata_array = [];
           let array_length;
  
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
  
           this.allAgents.push({
             recipient_name: res.name + '',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_subject_id: res.subject_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Agent',
           });
           } // end for loop
        //  this.allAgents = this.allAgents; // ?? this may be causing errors.
         // set records to send to subject_notes data table
        //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
  
              // array = res.assigned_to_agents;

            if (this.allAgents.lenght >= 1) {  } // end if no agents in list?
                  // array = JSON.parse(this.allAgents);
                  array = this.allAgents;
                  // console.log('array: ', array);
                      
                  ata_array = array.filter( (n: any) => (
                          n.recipient_brand_id === this.gfunc.sessionBrandId
                          // n.note_id >= '200'
                          // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
                          ));
                          // console.log('ata_array.lenght: ', ata_array.length);
                        
                        // does the check and decides if to display page or note
                          array_length = ata_array.length;
                          if (array_length >= 1) {
                            this.agent_associated = 1;
                          };
                          // blocks the access
                          if (array_length == 0) {
                          this.agent_associated = 0;
                          }
                          // console.log('Is Agent Associated? 0 | 1 : ', this.agent_associated);
              
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }




   getSubjectContactNumbers(subject_id) {
    this._demoService.getSubjectContactNumbers(subject_id).subscribe(
       data => { this.subject_contact_numbers = data; },
       err => console.log(err),
        () => {
          // console.log('done loading SCN');
                      }
          );
   }



   getSubjectContactEmails(subject_id) {
    this._demoService.getSubjectContactEmails(subject_id).subscribe(
       data => { this.subject_contact_emails = data; },
       err => console.log(err),
        () => {
          // console.log('done loading SR');
                      }
          );
   }
  

// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');

  this.modalRef.hide();
  this.getJobSubject(this.subject_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div

// :: Reloads the email list


};

}
